// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1lLl2","options":"AnswerScale_options__1H3Zk","selected":"AnswerScale_selected__CPtCW"};